import './condition-report-edit-screen-header.scss'

import _ from 'lodash';
import { defineComponent, PropType } from 'vue';

import { ArchiveResource, ConditionReport, ConditionReportStatePrefix, Wemi } from '@skinsoft/types';
import { conditionReportSelectors } from '@skinsoft/selectors';
import { WemiUtils } from '@skinsoft/wemi-utils';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { HeaderSearchFeaturedCard } from '@skinsoft/ui';
import { CollapsibleHeader } from '@skinsoft/ui/src/collapsible-header'
import { switchMap } from 'rxjs/operators';
import { toSearchFeatured$ } from '@skinsoft/search-data-store';
import { ArchiveCREditScreenHeader } from '../../archive/archive-cr-edit-screen-header';

export const ConditionReportEditScreenHeader = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sArchiveCrEditScreenHeader: ArchiveCREditScreenHeader,
        sHeaderSearchFeaturedCard: HeaderSearchFeaturedCard,
        sCollapsibleHeader: CollapsibleHeader,
    },
    props: {
        conditionReport: {
            type: Object as PropType<ConditionReport>,
            required: true,
        },
    },
    template: require('./condition-report-edit-screen-header.html'),
    data() {
        return {
            entity: null as ArchiveResource | Wemi | null,
        }
    },
    mounted() {
        if(this.getEntityType()) {
            this.fetchEntity()
        }
    },
    computed: {
        reportStatus() {
            const status = conditionReportSelectors.workflowState(this.conditionReport)
            if(status) {
                return `state.${status.replace(ConditionReportStatePrefix, '')}`
            }
            return undefined
        },
    },
    methods: {
        getEntityType(): string {

            const linkableItem = conditionReportSelectors.linkableItem(this.conditionReport)

            if(linkableItem && linkableItem.linkableItem) {
                if(linkableItem.linkableItemReferenceType) {
                    switch(linkableItem.linkableItemReferenceType.toLowerCase()) {
                        case "archive":
                            return "archive"
                    }
                }

                return "item"
            }

            return ""
        },

        fetchEntity() {
            const entityId = conditionReportSelectors.involvedItem(this.conditionReport)
            if(entityId) {
                switch(this.getEntityType()) {
                    case "archive":
                        this.$archiveDataStore.fetchOne(entityId).subscribe(
                            archive => {
                                this.entity = archive
                            },

                            error => {

                            },
                        )
                        break
                    case "specimen":
                        this.$specimenDataStore.fetchOne(entityId).subscribe(
                            specimen => {
                                this.entity = specimen
                            },

                            error => {

                            },
                        )
                        break
                    case "item":
                        this.$itemDataStore.fetchOne(entityId).pipe(
                            switchMap(item => {
                                return WemiUtils.getWemiFromItem(item.id)
                            }),
                            switchMap(wemi => {
                                return toSearchFeatured$(wemi, this.getAppLocale())
                            }),
                        ).subscribe(
                            featuredItem => {
                                // @ts-ignore
                                this.entity = featuredItem
                            },

                            error => {

                            }
                        )
                        break
                }
            }
        },
    },
})
